module.exports = __webpack_public_path__ + "static/media/leasetic.ad1c9f37.png";